module.exports = __webpack_public_path__ + "media/components/country-flag/static/aq-63613260f521d0a1422b4d71ef6b79b6.svg";